/** @format */

import React, { type FC, useState } from "react";
import styled, { css } from "styled-components";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import Box from "../../atoms/box/Box";
import Typography from "../../atoms/typography/Typography";
import Icon from "../../core/icon/Icon";
import type { TabsProps } from "./Tabs.types";

const Wrapper = styled.div<{ $width: string }>`
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  position: relative;
  display: flex;
  justify-content: flex-start;
  width: ${(props) => props.$width || "100%"};
  margin-left: -20px;
  overflow: hidden;
  pointer-events: all;
`;

const InnerWrapper = styled.div<TabsProps>`
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  --gradient: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(23, 0, 0, 0.75) ${(props) => (props.$start ? "0%" : "15%")},
    rgba(38, 0, 0, 1) ${(props) => (props.$start ? "0%" : "20%")},
    rgba(3, 0, 0, 1) ${(props) => (props.$end ? "100%" : "85%")},
    rgba(2, 0, 0, 0.75) ${(props) => (props.$end ? "100%" : "90%")},
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: var(--gradient);
  mask-image: var(--gradient);
`;

const Tab = styled.div<TabsProps>`
  cursor: pointer;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  opacity: ${({ active, theme }) => (active ? 1 : 0.4)};
  color: ${({ active, theme, inActiveColor }) =>
    active ? theme.colors.black : inActiveColor};

  display: flex;
  flex-direction: row;
  touch-action: pan-x;

  gap: 5px;
  padding-left: ${({ firstChild }) => (firstChild ? "20px" : "0px")};
  padding-right: ${({ lastChild }) => (lastChild ? "5px" : "15px")};
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  height: 100%;
  display: inline-flex;
  white-space: nowrap;

  &:hover {
    opacity: ${({ active }) => (active ? 1 : 0.55)};
  }
`;

// const TabGradientStart = styled.div`
//   pointer-events: none;
//   position: absolute;
//   z-index: 99;
//   left: 0;
//   height: 30px;
//   width: 60px;
//   background: linear-gradient(
//     270deg,
//     rgba(255, 255, 255, 0) 0%,
//     rgba(255, 255, 255, 1) 53%,
//     rgba(255, 255, 255, 1) 100%
//   );
// `;

// const TabGradientEnd = styled.div`
//   pointer-events: none;
//   position: absolute;
//   right: 0;
//   height: 30px;
//   width: 60px;
//   background: linear-gradient(
//     90deg,
//     rgba(255, 255, 255, 0) 0%,
//     rgba(255, 255, 255, 1) 53%,
//     rgba(255, 255, 255, 1) 100%
//   );
// `;

const SegmentControl: FC<TabsProps> = ({
  tabs,
  order,
  setOrder,
  inActiveColor,
  width,
}) => {
  // order, setOrder
  const isMobile = useIsMobile();
  const [start, setStart] = useState(true);
  const [end, setEnd] = useState(false);

  const handleScroll = (e) => {
    const element = e.target;
    if (element.scrollLeft + element.clientWidth >= element.scrollWidth - 4) {
      setEnd(true);
    } else if (element.scrollLeft <= 4) {
      setStart(true);
    } else {
      setStart(false);
      setEnd(false);
    }
  };

  // const fieldRef = React.useRef<HTMLInputElement>(null);

  const container = document.getElementById("container");

  return (
    <Wrapper $width={width}>
      {/* {!start && <TabGradientStart />} */}

      <InnerWrapper
        $start={start}
        $end={end}
        onScroll={handleScroll}
        // ref={fieldRef}
        id="container"
        className="hide-scrollbar"
      >
        {tabs.filter(Boolean).map((tab, index) => (
          <Tab
            key={tab.label}
            onClick={(e) => {
              if (index + 1 !== order) e.stopPropagation();
              setOrder?.(index + 1);
              if (!container) return;
              if (index + 1 > order) {
                container.scrollLeft += 100;
              } else {
                container.scrollLeft -= 100;
              }
            }}
            isMobile={isMobile}
            active={order === index + 1}
            tabs={tabs}
            inActiveColor={inActiveColor}
            firstChild={index === 0}
            lastChild={index === tabs.length - 1}
          >
            {tab.icon && (
              <Icon
                name={
                  order === index + 1 ? tab.activeIcon || tab.icon : tab.icon
                }
                transform={"scale(1.3)"}
                color={order === index + 1 ? "black" : inActiveColor}
              />
            )}
            <Box marginLeft="5px" alignItems="center">
              <Typography variant={"h3"} fontWeight={900} color="inherit">
                {tab.label}
              </Typography>
            </Box>
          </Tab>
        ))}
      </InnerWrapper>

      {/* {!end && <TabGradientEnd />} */}
    </Wrapper>
  );
};

export default SegmentControl;
